<div class="nav-item" role="link" [title]="label()" [class.nav-item--active]="active()">
  <div class="nav-item__icon">
    <app-icon [src]="icon()" [size]="24" />
  </div>
  @if (!collapsed()) {
    <span class="text-nav">{{ label() }}</span>
  }
</div>
